module.exports = __webpack_public_path__ + "images/unboxing_videos/play_button-439019d51c90aaec52dc492dd3a407db.png";